import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarMenuComponent } from './sidebar-menu/sidebar-menu.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TouchNavbarComponent } from './touch-navbar/touch-navbar.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { ReplacePipe } from '../_helpers/replace.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbModule
  ],
  declarations: [
    FooterComponent,
    TouchNavbarComponent,
    SidebarMenuComponent,
    ConfirmModalComponent,
    ReplacePipe
  ],
  exports: [
    FooterComponent,
    TouchNavbarComponent,
    SidebarMenuComponent,
    ConfirmModalComponent,
    ReplacePipe
  ]
})
export class ComponentsModule { }
